<template>
  <div ref="wrapper" class="bg-[#f7f8fb] pt-1 pb-6 w-full relative" :class="{ 'invisible h-0 my-0': !isAdLoaded }">
    <div class="text-[#7F8083] text-13 font-semibold leading-16 pb-1 u-center">
      {{ entryNumber === entriesNumber - 1 ? $t('news-page.article-bottom-ad-title') : $t('news-page.article-ad-title') }}
      <OIcon icon="chevron-right-grey" class="rotate-90 ml-1.5" />
    </div>
    <div id="teads-div-1" class="OND_VIDEO"></div>
    <div class="absolute right-1 bottom-1 flex justify-end text-xs text-primary-200">{{ $t('main.ads') }}</div>
  </div>
</template>

<script>
import { defineComponent, onMounted, onUnmounted, ref, inject } from '@nuxtjs/composition-api';
import { OIcon } from '~/modules/common/components/ui';
import { useDevice } from '~/composables/useDevice';
export default defineComponent({
  components: { OIcon },
  props: {
    entriesNumber: {
      type: Number,
      reuire: true,
    },
    entryNumber: {
      type: Number,
      require: true,
    },
  },
  setup() {
    const wrapper = ref(null);
    const isAdLoaded = ref(false);
    const article = inject('article');
    const { isMobile } = useDevice();

    let observer = null;

    const isMembranaAds = () => {
      if (isMobile.value) {
        const excludeCategories = ['Goygoy', 'Spor', 'Gaming'];
        const isMembranaCategory = article?.breadcrumb?.reverse().some((cat) => {
          return excludeCategories.includes(cat.name);
        });
        return !isMembranaCategory;
      }
      return false;
    };

    onMounted(() => {
      const adElement = wrapper.value.querySelector('.OND_VIDEO');

      // Aşağıdaki alanlar teads ve membrana firmalarının callback vermeleri ile tekrar düzeltilecektir.
      observer = new MutationObserver((list) => {
        // Aşağıdaki alanlar teads ve membrana firmalarının callback'leri ile değiştirilecektir.
        // Teads ve Membrana maalesef reklamların yüklenip yüklenmediği konusunda callback veremedikleri için bu şekilde manuel kontrol sağlanacaktır.
        if (isMembranaAds()) {
          isAdLoaded.value =
            typeof list[0].addedNodes === 'object' &&
            Object.values(list[0].addedNodes).some((node) => node?.classList?.contains('nts-container'));
        } else {
          // isAdLoaded.value = isTeadsLoaded();
          isAdLoaded.value = !!list[0].addedNodes[0]?.querySelector('.teads-player');
        }
        observer.disconnect();
      });
      observer.observe(adElement, { childList: true });
    });

    onUnmounted(() => observer && observer.disconnect());

    return { wrapper, isAdLoaded };
  },
});
</script>
